import { AbstractControl, FormGroup, ValidationErrors, ValidatorFn } from '@angular/forms';

export function extractRichTextPlainText(value: string): string {
  return value
    .replace(/<[^>]*>/g, ' ')
    .replace(/&nbsp;/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
}

export const richTextRequiredValidator: ValidatorFn = (
  control: AbstractControl<string | null>,
): ValidationErrors | null => {
  return extractRichTextPlainText(control.value ?? '').length > 0 ? null : { required: true };
};

function parseDdMmYyyy(value: string): number | null {
  const match = /^(\d{2})\/(\d{2})\/(\d{4})$/.exec(value);
  if (!match) return null;
  return new Date(+match[3], +match[2] - 1, +match[1]).getTime();
}

export const dateRangeValidator: ValidatorFn = (
  group: AbstractControl,
): ValidationErrors | null => {
  const from = (group as FormGroup).get('validFrom')?.value as string;
  const to = (group as FormGroup).get('validTo')?.value as string;
  if (!from || !to) return null;
  const fromTs = parseDdMmYyyy(from);
  const toTs = parseDdMmYyyy(to);
  if (fromTs !== null && toTs !== null && toTs < fromTs) {
    return { dateRangeInvalid: true };
  }
  return null;
};
